import script from "./order-confirmation-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./order-confirmation-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__